'use client'

import { useState } from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { usePathname, useSearchParams } from 'next/navigation'

export default function NavBarSearch() {
  const [selected, setSelected] = useState(false)
  const [query, setQuery] = useState('')
  const searchParams = useSearchParams()
  const searchString = searchParams.get('searchString');
  const pathname = usePathname();

  if (searchString != undefined && searchString.length && !query.length) {
    setQuery(searchString)
  }

  const inputWidthClass: string = selected ? 'w-48' : 'w-0';

  return (
    (pathname == '/' || pathname == '/search')
      ?
      <div className="w-full grid group"></div>
      :
      <div className="w-full grid group" onMouseEnter={() => setSelected(true)}>
        <div
          onMouseLeave={() => !query.length && setSelected(false)}
          className="ease-in-out duration-700 transition-all place-self-end border border-white group-hover:border-gray-600 rounded flex place-items-center px-2 py-1">
          <MagnifyingGlassIcon className="w-[24px] transition-all ease-in-out duration-700" />
          <form method="get" action="/search">
            <input type="text"
              onClick={() => setSelected(true)}
              onBlur={() => !query.length && setSelected(false)}
              onInput={(e) => {
                const target = e.target as HTMLInputElement
                setQuery(target.value)
              }}
              placeholder='Search all Acquia'
              value={query}
              name="searchString"
              className={`${inputWidthClass} transition-all ease-in-out duration-700 p-2 placeholder:text-gray-600 placeholder:italic`} />
          </form>
        </div>
      </div>
  )
}
